var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubAccountants(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.8303 31.873L14.8362 31.8658H14.8237L14.8303 31.873Z",
    fill: "#F9AA2A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M19.2497 20.1647C19.2497 19.1277 19.6606 18.1875 20.3229 17.4865C19.7271 17.2545 19.1179 17.049 18.4896 16.8883C21.1726 15.0825 23.0204 11.5235 23.0204 8.31849C23.0204 3.79544 19.3514 0.127014 14.8301 0.127014C10.3076 0.127014 6.6398 3.79444 6.6398 8.31849C6.6398 11.5235 8.4878 15.0827 11.1706 16.8883C4.75507 18.5162 0 24.0862 0 28.2135C0 30.6523 7.41068 31.8656 14.8245 31.8656L10.6756 27.7179L14.1725 19.2628H14.137L12.7778 17.705C13.4352 17.9408 14.1193 18.0831 14.8299 18.0831C15.54 18.0831 16.2234 17.9406 16.8791 17.7062L15.52 19.2616H15.4868L18.9838 27.7167L14.8348 31.8656C16.768 31.8656 18.7023 31.7858 20.5041 31.6203C19.7368 30.905 19.2474 29.8934 19.2474 28.7623V20.1647H19.2497Z",
    fill: "#F9AA2A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M29.3181 17.4829H23.1679C21.6899 17.4829 20.4873 18.6865 20.4873 20.1647V28.7623C20.4873 30.2415 21.6899 31.4453 23.1679 31.4453H29.3181C30.7961 31.4453 31.9999 30.2417 31.9999 28.7623V20.1647C31.9999 18.6855 30.7963 17.4829 29.3181 17.4829ZM31.2338 28.7623C31.2338 29.8184 30.3757 30.6766 29.3183 30.6766H23.1681C22.1118 30.6766 21.2536 29.8186 21.2536 28.7623V20.1647C21.2536 19.1072 22.1116 18.2478 23.1681 18.2478H29.3183C30.3757 18.2478 31.2338 19.1072 31.2338 20.1647V28.7623Z",
    fill: "#F9AA2A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M23.6415 26.1251H22.7714C22.5743 26.1251 22.4136 26.2267 22.4136 26.35V26.8988C22.4136 27.022 22.5743 27.1235 22.7714 27.1235H23.6415C23.8372 27.1235 23.9994 27.022 23.9994 26.8988V26.35C23.9992 26.2267 23.8372 26.1251 23.6415 26.1251Z",
    fill: "#F9AA2A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M29.4825 19.7007H23.0035C22.5792 19.7007 22.2324 20.0111 22.2324 20.3917V22.0742C22.2324 22.4537 22.5792 22.7643 23.0035 22.7643H29.4825C29.9081 22.7643 30.256 22.4539 30.256 22.0742V20.3917C30.2562 20.0123 29.9069 19.7007 29.4825 19.7007Z",
    fill: "#F9AA2A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M25.6671 26.1251H24.7956C24.5987 26.1251 24.439 26.2267 24.439 26.35V26.8988C24.439 27.022 24.5987 27.1235 24.7956 27.1235H25.6671C25.864 27.1235 26.0248 27.022 26.0248 26.8988V26.35C26.0248 26.2267 25.864 26.1251 25.6671 26.1251Z",
    fill: "#F9AA2A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M27.6899 26.1251H26.8198C26.6215 26.1251 26.4619 26.2267 26.4619 26.35V26.8988C26.4619 27.022 26.6215 27.1235 26.8198 27.1235H27.6899C27.887 27.1235 28.0477 27.022 28.0477 26.8988V26.35C28.0477 26.2267 27.887 26.1251 27.6899 26.1251Z",
    fill: "#F9AA2A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M29.7158 26.1251H28.8454C28.6486 26.1251 28.4878 26.2267 28.4878 26.35V26.8988C28.4878 27.022 28.6486 27.1235 28.8454 27.1235H29.7158C29.9115 27.1235 30.0734 27.022 30.0734 26.8988V26.35C30.0734 26.2267 29.9117 26.1251 29.7158 26.1251Z",
    fill: "#F9AA2A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M22.7704 25.359H23.6394C23.8375 25.359 23.997 25.2574 23.997 25.1329V24.5853C23.997 24.4609 23.8375 24.3593 23.6394 24.3593H22.7704C22.5734 24.3593 22.4126 24.4609 22.4126 24.5853V25.1329C22.4126 25.2574 22.5734 25.359 22.7704 25.359Z",
    fill: "#F9AA2A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M24.7944 25.359H25.6645C25.8614 25.359 26.0223 25.2574 26.0223 25.1329V24.5853C26.0223 24.4609 25.8614 24.3593 25.6645 24.3593H24.7944C24.5961 24.3593 24.4365 24.4609 24.4365 24.5853V25.1329C24.4367 25.2574 24.5961 25.359 24.7944 25.359Z",
    fill: "#F9AA2A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M26.8178 25.359H27.6891C27.8862 25.359 28.047 25.2574 28.047 25.1329V24.5853C28.047 24.4609 27.8862 24.3593 27.6891 24.3593H26.8178C26.6219 24.3593 26.46 24.4609 26.46 24.5853V25.1329C26.46 25.2574 26.6217 25.359 26.8178 25.359Z",
    fill: "#F9AA2A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M28.8432 25.359H29.7157C29.9114 25.359 30.0734 25.2574 30.0734 25.1329V24.5853C30.0734 24.4609 29.9116 24.3593 29.7157 24.3593H28.8432C28.6475 24.3593 28.4854 24.4609 28.4854 24.5853V25.1329C28.4854 25.2574 28.6473 25.359 28.8432 25.359Z",
    fill: "#F9AA2A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M23.6394 27.4001H22.7717C22.5734 27.4001 22.4116 27.5017 22.4116 27.6262V28.1738C22.4116 28.2982 22.5734 28.3998 22.7717 28.3998H23.6394C23.8375 28.3998 23.997 28.296 23.997 28.1738V27.6262C23.997 27.5015 23.8375 27.4001 23.6394 27.4001Z",
    fill: "#F9AA2A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M25.666 27.4001H24.7935C24.5992 27.4001 24.4395 27.5017 24.4395 27.6262V28.1738C24.4395 28.2982 24.5992 28.3998 24.7935 28.3998H25.666C25.8631 28.3998 26.0239 28.296 26.0239 28.1738V27.6262C26.0239 27.5015 25.8631 27.4001 25.666 27.4001Z",
    fill: "#F9AA2A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M27.6899 27.4001H26.8198C26.6215 27.4001 26.4619 27.5017 26.4619 27.6262V28.1738C26.4619 28.2982 26.6215 28.3998 26.8198 28.3998H27.6899C27.887 28.3998 28.0477 28.296 28.0477 28.1738V27.6262C28.0477 27.5015 27.887 27.4001 27.6899 27.4001Z",
    fill: "#F9AA2A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M29.7131 27.4001H28.8454C28.6473 27.4001 28.4854 27.5017 28.4854 27.6262V28.1738C28.4854 28.2982 28.6473 28.3998 28.8454 28.3998H29.7131C29.9114 28.3998 30.0732 28.296 30.0732 28.1738V27.6262C30.0732 27.5015 29.9114 27.4001 29.7131 27.4001Z",
    fill: "#F9AA2A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M23.6391 28.6753H22.7688C22.5731 28.6753 22.4111 28.7767 22.4111 28.9V29.4488C22.4111 29.572 22.5729 29.6737 22.7688 29.6737H23.6391C23.8372 29.6737 23.9968 29.572 23.9968 29.4488V28.9C23.9968 28.7765 23.8372 28.6753 23.6391 28.6753Z",
    fill: "#F9AA2A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M25.666 28.6753H24.7935C24.5992 28.6753 24.437 28.7767 24.437 28.9V29.4488C24.437 29.572 24.599 29.6737 24.7935 29.6737H25.666C25.8631 29.6737 26.0238 29.572 26.0238 29.4488V28.9C26.0238 28.7765 25.8631 28.6753 25.666 28.6753Z",
    fill: "#F9AA2A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M27.6891 28.6753H26.8178C26.6219 28.6753 26.46 28.7767 26.46 28.9V29.4488C26.46 29.572 26.6217 29.6737 26.8178 29.6737H27.6891C27.8862 29.6737 28.047 29.572 28.047 29.4488V28.9C28.047 28.7765 27.8862 28.6753 27.6891 28.6753Z",
    fill: "#F9AA2A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M29.7133 28.6753H28.8432C28.6475 28.6753 28.4854 28.7767 28.4854 28.9V29.4488C28.4854 29.572 28.6473 29.6737 28.8432 29.6737H29.7133C29.909 29.6737 30.0712 29.572 30.0712 29.4488V28.9C30.071 28.7765 29.909 28.6753 29.7133 28.6753Z",
    fill: "#F9AA2A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubAccountants);
export default __webpack_public_path__ + "static/media/subAccountants.05f798577ad97a9a96c1a82213cc560d.svg";
export { ForwardRef as ReactComponent };